import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ActionButtons = () => {
  const { t } = useTranslation();

  return (
    <div className="container" style={{ padding: '0 10px', maxWidth: '500px', margin: '0 auto' }}>
      <div
        className="btns text-center flex flex-row justify-between items-center mt-4 mb-3"
        style={{ overflowX: 'auto', gap: '25px' }}
      >
        <Link
          to="/rebook"
          className="theme-btn-s2 rounded-btn"
          style={{ 
            borderRadius: '8px', 
            padding: '10px 15px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '120px',
            height: '70px',
            justifyContent: 'center'
          }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <i className="fas fa-calendar-alt"></i>
          <span>{t('rebook_ticket')}</span>
        </Link>
        <Link
          to="/refund"
          className="theme-btn-s2 rounded-btn"
          style={{ 
            borderRadius: '8px', 
            padding: '10px 15px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '120px',
            height: '70px',
            justifyContent: 'center'
          }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <i className="fas fa-sync-alt"></i>
          <span>{t('refund_ticket')}</span>
        </Link>
        <Link
          to="/print"
          className="theme-btn-s2 rounded-btn"
          style={{ 
            borderRadius: '8px', 
            padding: '10px 15px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '120px',
            height: '70px',
            justifyContent: 'center'
          }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <i className="fas fa-print"></i>
          <span>{t('print_ticket')}</span>
        </Link>
      </div>
    </div>
  );
};

export default ActionButtons;
